import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueGtag from 'vue-gtag'
import './plugins'
import { Plugin } from 'vue-responsive-video-background-player'

// Add Google Analytics Tag here
Vue.use(VueGtag, {
	config: { id: '' },
})

Vue.use(Plugin)

Vue.config.productionTip = false

new Vue({
	router,
	vuetify,
	render: h => h(App),
}).$mount('#app')
